import { Injectable } from '@angular/core';
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DebitBalanceService {
    public sessionId: string;

    constructor(
        private backendService: BackendService,
        private store: Store<AppState> 
    ) {}

    public getDebitBalance() {
        try {
            this.fillSessionId();
            return this.backendService.api.get('/toro-lumen/v2/finance/debit-balance')   
        } catch (error) {
            console.error(error);
        }
    }

    private fillSessionId = () => {
        this.store
            .select(({authentication}) => authentication.currentUser)
            .pipe(
                filter((authentication) => !!authentication)
            )
            .subscribe((user) => {
                this.sessionId = user.sessionId
            })
    }
}
